// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1WxYZ","header":"MessagesList_header__3go0_","chat":"MessagesList_chat__1bKJv"};